import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TitleComponent} from './title.component';
import {HighlightEndTextModule} from '../highlight-end-text/highlight-end-text.module';


@NgModule({
  declarations: [TitleComponent],
  imports: [
    CommonModule,
    HighlightEndTextModule
  ],
  exports: [TitleComponent]
})
export class TitleModule {
}
